import { render, staticRenderFns } from "./NotLoggedInAppFooter.vue?vue&type=template&id=35c74fbc"
import script from "./NotLoggedInAppFooter.vue?vue&type=script&lang=js"
export * from "./NotLoggedInAppFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports